import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-vdd-write-error-modal',
  templateUrl: './vdd-write-error-modal.component.html',
  styleUrls: ['./vdd-write-error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddWriteErrorModalComponent {
  constructor(public dialogRef: MatDialogRef<VddWriteErrorModalComponent>) {}
}
